import { Input } from "reactstrap";
import { Form, Field } from "react-final-form";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useDispatch, flashError } from "@/shared/components/flash";
import SelectProgram from "../../components/SelectProgram";
import { isEmpty } from "@/shared/helpers";
import PaymentCreditCardStep_1 from "./PaymentCreditCardStep1Form";

const PaymentCreditCardForm = ({ toggle: parentToggle, program, btnLabel }) => {
  const [isOpen, setOpen] = useState(false);
  const [amount, setAmount] = useState(null);
  const [pId, setpId] = useState(program.id);

  const orgId = program?.organization_id ?? null;

  const toggle = () => setOpen(prev => !prev);

  const onProgramChange = (e) => setpId(e.target.value);

  const onSubmit = values => {
    if (!isEmpty(values)) {
      setAmount(values.amount);
      toggle();
    }
  };

  const validate = values => {
    const errors = {};
    if (isEmpty(values)) {
      errors.amount = "Please enter an amount";
    } else if (isNaN(parseFloat(values.amount)) || parseFloat(values.amount) <= 0) {
      errors.amount = "Please enter a valid amount";
    }
    return errors;
  };

  if (!orgId) return "Loading...";

  return (
    <>
      <Form onSubmit={onSubmit} validate={validate} keepDirtyOnReinitialize>
        {({ handleSubmit }) => (
          <form className="cc-deposit-form" onSubmit={handleSubmit}>

            <div className="cc-deposit-form__field">
              <label className="cc-deposit-form__label">Select Program</label>
              <SelectProgram
                label=""
                showRefresh={false}
                selected={pId}
                onChange={onProgramChange}
              />
            </div>

            <Field name="amount">
              {({ input, meta }) => (
                <div className="cc-deposit-form__field">
                  <label className="cc-deposit-form__label">Amount</label>
                  <div className="cc-deposit-form__amount-wrap">
                    <span className="cc-deposit-form__currency">$</span>
                    <Input
                      {...input}
                      type="text"
                      placeholder="0.00"
                      className="cc-deposit-form__input"
                    />
                  </div>
                  {meta.touched && meta.error && (
                    <span className="cc-deposit-form__error">{meta.error}</span>
                  )}
                </div>
              )}
            </Field>

            <div className="cc-deposit-form__actions">
              <button type="button" className="cc-deposit-form__btn cc-deposit-form__btn--cancel" onClick={parentToggle}>
                Cancel
              </button>
              <button type="submit" className="cc-deposit-form__btn cc-deposit-form__btn--submit">
                {btnLabel || "Make Deposit"}
              </button>
            </div>

          </form>
        )}
      </Form>

      <PaymentCreditCardStep_1
        amount={amount}
        isOpen={isOpen}
        setOpen={setOpen}
        toggle={toggle}
        pId={pId}
        orgId={orgId}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  program: state.program,
  rootProgram: state.rootProgram,
});

export default connect(mapStateToProps)(PaymentCreditCardForm);
